import Vue from 'vue';
import App from './App.vue';
import router from './router';
import axios from 'axios';
import moment from 'moment'; // 解决时间戳格式
import ElementUI, { Message } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
import './assets/css/icon.css';
import 'babel-polyfill';
import { localStg } from '@/utils/storage/local';
import { EnumLocalStore } from '@/constant/enums';
import { message } from '@/utils/message';
import modal from '@/plugins/modal';

import('./service/request/server')

Vue.config.productionTip = false;
Vue.prototype.$message = Message
Vue.prototype.$modal = modal
ElementUI.Dialog.props.closeOnClickModal.default=false
Vue.use(
    ElementUI, {
        size: 'small'
    },
);

Vue.prototype.$moment = moment        // 解决时间戳格式
Vue.prototype.$axios = axios

const skipRoutPathArr = ['/register', '/retrieve', '/login', '/phoneLogin', '/forgetPwd', '/emailLogin', '/emailRegister'];


//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
    document.title = `${to.meta.title} `;
    //登录前不可进首页
    if (!localStg.get(EnumLocalStore.jwtTokenName)) {
        // 并且进的不是注册页
        if (skipRoutPathArr.indexOf(to.path) === -1) {
            localStg.clear();
            next('/login');
            message.error('登录信息过期，请重新登录');
        }
    }
    next()
});


new Vue({
    router,
    render: h => h(App),
    axios,
}).$mount('#app');
